"use client"

/**
 * Analytics module — centralized PostHog event tracking.
 *
 * Primary API:
 *   import { track } from "@/shared/lib/analytics"
 *   track("auth:signup_start", { method: "email" })
 *
 * Legacy API (deprecated — use track() instead):
 *   import { trackEvent } from "@/shared/lib/analytics"
 *   trackEvent("some_event", { key: "value" })
 */

// New typed API
export { track, registerSuperProperties } from "./track"
export {
  configureActivationTracking,
  clearActivationTracking,
  getCurrentActivationChatMessageCount,
} from "./activation"
export type { AnalyticsEvent, EventPropertyMap } from "./events"

// Legacy API (kept for backward compatibility)
export {
  trackEvent,
  identifyUser,
  resetUser,
  getTrackdeskClickId,
} from "./legacy"
